module.exports = __webpack_public_path__ + "static/impressum-fd3564070306a3fff650c67ab0984e4d.pdf";